customElements.get("pickup-availability")||customElements.define("pickup-availability",class extends HTMLElement{constructor(){super(),this.hasAttribute("available")&&(this.errorHtml=this.querySelector("template").content.firstElementChild.cloneNode(!0),this.onClickRefreshList=this.onClickRefreshList.bind(this),this.fetchAvailability(this.dataset.variantId),this.pickupAvailabilityDrawer=this.querySelector("pickup-availability-drawer"))}fetchAvailability(t){let e=this.dataset.rootUrl;e.endsWith("/")||(e+="/");fetch(`${e}variants/${t}/?section_id=pickup-availability`).then(t=>t.text()).then(t=>{const e=(new DOMParser).parseFromString(t,"text/html").querySelector(".shopify-section");this.renderPreview(e)}).catch(t=>{const e=this.querySelector("button");e&&e.removeEventListener("click",this.onClickRefreshList),this.renderError()})}onClickRefreshList(t){this.fetchAvailability(this.dataset.variantId)}renderError(){this.innerHTML="",this.appendChild(this.errorHtml),this.querySelector("button").addEventListener("click",this.onClickRefreshList)}renderPreview(t){const e=document.querySelector("pickup-availability-drawer");if(e&&e.remove(),!t.querySelector("pickup-availability-preview"))return this.innerHTML="",void this.removeAttribute("available");this.innerHTML=t.querySelector("pickup-availability-preview").outerHTML,this.setAttribute("available",""),document.body.appendChild(t.querySelector("pickup-availability-drawer"));const i=this.querySelector("button");i&&i.addEventListener("click",t=>{document.querySelector("pickup-availability-drawer").show(t.target)})}}),customElements.get("pickup-availability-drawer")||customElements.define("pickup-availability-drawer",class extends HTMLElement{constructor(){super(),this.onBodyClick=this.handleBodyClick.bind(this),this.backDrop=document.getElementById("base-backdrop"),this.closeButton=this.querySelector("button[data-modal-close], button.pickup-availability-drawer-button, .pickup-availability-drawer__close, .base-modal__close"),this.closeButton&&this.closeButton.addEventListener("click",()=>{this.hide()}),this.addEventListener("keyup",t=>{"ESCAPE"===t.code.toUpperCase()&&this.hide()})}handleBodyClick(t){const e=t.target;e==this||e.closest("pickup-availability-drawer")||"ShowPickupAvailabilityDrawer"==e.id||this.hide()}hide(){this.removeAttribute("open"),document.body.removeEventListener("click",this.onBodyClick),document.documentElement.classList.remove("overflow-hidden"),document.documentElement.style.paddingRight="",this.backDrop&&this.backDrop.classList.remove("active"),removeTrapFocus(this.focusElement)}show(t){this.focusElement=t,this.setAttribute("open",""),document.body.addEventListener("click",this.onBodyClick);const e=window.innerWidth-document.documentElement.clientWidth;document.documentElement.classList.add("overflow-hidden"),document.documentElement.style.paddingRight=e+"px",this.backDrop&&this.backDrop.classList.add("active"),requestAnimationFrame(()=>{this.closeButton&&this.closeButton.removeAttribute("tabindex"),trapFocus(this,this.closeButton||this),this.closeButton&&setTimeout(()=>{this.closeButton.focus()},50)})}});

// if (!customElements.get('pickup-availability')) {
//   customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
//     constructor() {
//       super();

//       if(!this.hasAttribute('available')) return;

//       this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
//       this.onClickRefreshList = this.onClickRefreshList.bind(this);
//       this.fetchAvailability(this.dataset.variantId);
//       this.pickupAvailabilityDrawer = this.querySelector('pickup-availability-drawer');
//     }

//     fetchAvailability(variantId) {
//       let rootUrl = this.dataset.rootUrl;
//       if (!rootUrl.endsWith("/")) {
//         rootUrl = rootUrl + "/";
//       }
//       const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

//       fetch(variantSectionUrl)
//         .then(response => response.text())
//         .then(text => {
//           const sectionInnerHTML = new DOMParser()
//             .parseFromString(text, 'text/html')
//             .querySelector('.shopify-section');
//           this.renderPreview(sectionInnerHTML);
//         })
//         .catch(e => {
//           const button = this.querySelector('button');
//           if (button) button.removeEventListener('click', this.onClickRefreshList);
//           this.renderError();
//         });
//     }

//     onClickRefreshList(evt) {
//       this.fetchAvailability(this.dataset.variantId);
//     }

//     renderError() {
//       this.innerHTML = '';
//       this.appendChild(this.errorHtml);

//       this.querySelector('button').addEventListener('click', this.onClickRefreshList);
//     }

//     renderPreview(sectionInnerHTML) {
//       const drawer = document.querySelector('pickup-availability-drawer');
//       if (drawer) drawer.remove();
//       if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
//         this.innerHTML = "";
//         this.removeAttribute('available');
//         return;
//       }

//       this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
//       this.setAttribute('available', '');

//       document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

//       const button = this.querySelector('button');
//       if (button) button.addEventListener('click', (evt) => {
//         document.querySelector('pickup-availability-drawer').show(evt.target);
//       });
//     }
//   });
// }

// if (!customElements.get('pickup-availability-drawer')) {
//   customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
//     constructor() {
//       super();

//       this.onBodyClick = this.handleBodyClick.bind(this);
//       this.backDrop = document.getElementById('base-backdrop');

//       this.closeButton = this.querySelector(
//         'button[data-modal-close], ' +
//         'button.pickup-availability-drawer-button, ' +  // ← Your actual class
//         '.pickup-availability-drawer__close, ' +
//         '.base-modal__close'
//       );
      
//       if (this.closeButton) {
//         this.closeButton.addEventListener('click', () => {
//           this.hide();
//         });
//       }

//       this.addEventListener('keyup', (event) => {
//         if(event.code.toUpperCase() === 'ESCAPE') this.hide();
//       });
//     }

//     handleBodyClick(evt) {
//       const target = evt.target;
//       if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
//         this.hide();
//       }
//     }

//     hide() {
//       this.removeAttribute('open');
//       document.body.removeEventListener('click', this.onBodyClick);
//       document.documentElement.classList.remove('overflow-hidden');
//       document.documentElement.style.paddingRight = "";
//       if (this.backDrop) this.backDrop.classList.remove('active');
      
//       removeTrapFocus(this.focusElement);
//     }

//     show(focusElement) {
//       this.focusElement = focusElement;
//       this.setAttribute('open', '');
//       document.body.addEventListener('click', this.onBodyClick);
//       const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
//       document.documentElement.classList.add('overflow-hidden');
//       document.documentElement.style.paddingRight = scrollBarWidth + "px";
//       if (this.backDrop) this.backDrop.classList.add('active');
      
//       requestAnimationFrame(() => {
//         if (this.closeButton) {
//           this.closeButton.removeAttribute('tabindex');
//         }
        
//         trapFocus(this, this.closeButton || this);
//         if (this.closeButton) {
//           setTimeout(() => {
//             this.closeButton.focus();
//           }, 50);
//         }
//       });
//     }
//   });
// }
